var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83331 9.5H7.49998V11.1667H5.83331V9.5ZM5.83331 12.8333H7.49998V14.5H5.83331V12.8333ZM9.16665 9.5H10.8333V11.1667H9.16665V9.5ZM9.16665 12.8333H10.8333V14.5H9.16665V12.8333ZM12.5 9.5H14.1666V11.1667H12.5V9.5ZM12.5 12.8333H14.1666V14.5H12.5V12.8333Z",
    fill: "#6A7187"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 18.6667H15.8333C16.7525 18.6667 17.5 17.9192 17.5 17V7V5.33333C17.5 4.41417 16.7525 3.66667 15.8333 3.66667H14.1667V2H12.5V3.66667H7.5V2H5.83333V3.66667H4.16667C3.2475 3.66667 2.5 4.41417 2.5 5.33333V7V17C2.5 17.9192 3.2475 18.6667 4.16667 18.6667ZM15.8333 7L15.8342 17H4.16667V7H15.8333Z",
    fill: "#6A7187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCalendar);
export default __webpack_public_path__ + "static/media/bx-calendar.152a4726.svg";
export { ForwardRef as ReactComponent };